import { render } from "./Page403.vue?vue&type=template&id=3a3d7fdc&scoped=true"
import script from "./Page403.vue?vue&type=script&lang=js"
export * from "./Page403.vue?vue&type=script&lang=js"

import "./Page403.vue?vue&type=style&index=0&id=3a3d7fdc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3d7fdc"]])

export default __exports__